import React from 'react'

import * as S from './styled'
import type { Props } from './types'

export const ContributionSummarySection = ({ children }: Props) => (
  <S.Container>{children}</S.Container>
)
